import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

export function addressGet() {
  return axios.request({
    url: `${urlObj.crm}crm/resarea/gateway/area`,
    method: 'get'
  })
}

export function addressPost(params, data) {
  return axios.request({
    url: `${urlObj.wss}wss-order/address/info`,
    method: 'post',
    params,
    data
  })
}
